// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkCard-cls1_VQA","cls2":"WorkCard-cls2_807 WorkCard-cls1_VQA","highlightPulse":"WorkCard-highlightPulse_FTN"};